import React, { useEffect, useRef } from 'react';
import Style from './Home.module.scss';
import classNames from 'classnames';
import { info } from '../Info/Info';
import { 
  trackSectionView, 
  trackTimeOnSection,
  trackSocialMediaClick 
} from "../utils/analytics";

export default function Home() {
    const sectionRef = useRef(null);
    const sectionStartTime = useRef(null);
    const hasTrackedView = useRef(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        sectionStartTime.current = Date.now();
                        if (!hasTrackedView.current) {
                            trackSectionView('home');
                            hasTrackedView.current = true;
                        }
                    } else if (sectionStartTime.current) {
                        const timeSpent = Math.round((Date.now() - sectionStartTime.current) / 1000);
                        if (timeSpent > 1) {
                            trackTimeOnSection('home', timeSpent);
                        }
                        sectionStartTime.current = null;
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
                if (sectionStartTime.current) {
                    const timeSpent = Math.round((Date.now() - sectionStartTime.current) / 1000);
                    if (timeSpent > 1) {
                        trackTimeOnSection('home', timeSpent);
                    }
                }
            }
        };
    }, []);

    const handleSocialClick = (platform, url) => {
        trackSocialMediaClick(platform, url);
    };
    const firstNameStyle = {
        background: info.gradient,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent"
    }

    let bio = info.miniBio;

    function createList() {
        let results = [];
        for (let i = 0; i < bio.length; i++) {
            let value = bio[i];
            results.push(
                <li key={i}><span aria-label="emoji" role="img" className={Style.emoji}>{value[0]}</span> {value[1]}</li>
            )
        }
        return results;
    }

    let socials = info.socials;

    function socialList() {
        let results = [];
        for (let i = 0; i < socials.length; i++) {
            let value = socials[i];
            results.push(
                <a 
                    key={i}
                    style={{ marginLeft: 20 }} 
                    target="_blank" 
                    href={value[0]}
                    onClick={() => handleSocialClick(value[1], value[0])}
                >
                    {value[1]}
                </a>
            )
        }
        return results
    }

    return (
        <main id="home" className={classNames(Style.mainContainer, Style.light)} ref={sectionRef}>
            <div className={classNames(Style.container, Style.light)}>
                                <div className={classNames(Style.avatar, Style.shadowed)} style={{ background: info.gradient }}>
                                        <img 
                                            src={info.selfPortrait} 
                                            alt={`Portrait of ${info.firstName} – ${info.position}`} 
                                            className={Style.mainImg} 
                                            loading="eager"
                                            decoding="async" 
                                        />
                                </div>
                <div className={Style.mainText}>
                    <h1>{info.position}</h1>
                    <p className={Style.leadIntro}>Building performant mobile & web applications with React Native, React.js & Node.js.</p>
                    <ul>
                        {createList()}
                    </ul>
                    <div className={Style.socials}>
                        {socialList()}
                    </div>
                </div>
            </div>
        </main>
    )
}